const htmlContent = `
<div id="markdown">
<h1 id="matomo-hinter-traefik">Matomo hinter Traefik</h1>
<h2 id="einleitung">Einleitung</h2>
<p>Ich betreibe mehrere Root-Server für verschiedene Projekte.
Mit Traefik lassen sich darauf recht einfach viele Dienste mit beliebigen Domains, URLs und Ports hosten.
Natürlich benötigt man ein funktionierendes DNS, das diese Domains auf den Server zeigen lässt, auf dem Traefik läuft.</p>
<p>In diesem Beispiel werden Anfragen an Ihre Homepage und an Matomo über Traefik als Ingress-Controller geroutet.</p>
<h2 id="voraussetzungen">Voraussetzungen</h2>
<ol>
<li>Klonen Sie <a href="https://github.com/ludwigprager/matomo-behind-traefik">dieses Repository</a>.  <pre><code>git clone https://github.com/ludwigprager/matomo-behind-traefik
</code></pre>
</li>
<li>Ersetzen Sie alle Vorkommen (<a href="https://github.com/ludwigprager/matomo-behind-traefik/blob/main/configuration/conf.yaml#L6">hier</a>, <a href="https://github.com/ludwigprager/matomo-behind-traefik/blob/main/configuration/conf.yaml#L15">hier</a> und <a href="https://github.com/ludwigprager/matomo-behind-traefik/blob/main/traefik.yaml#L25">hier</a>) von <code>example.com</code> durch Ihre Domain.</li>
<li>Lassen Sie Ihr DNS die Subdomains <code>www.&lt;yourdomain&gt;</code> und <code>matomo.&lt;yourdomain&gt;</code> auf diesen Server zeigen.  </li>
</ol>
<h2 id="traefik-starten">Traefik starten</h2>
<p>Starten Sie Traefik nun mit</p>
<pre><code>./matomo-behind-traefik/restart.sh
</code></pre>
<p>Die Zertifikate werden signiert und eingerichtet.
Traefik kann aber noch keinen Dienst erreichen.</p>
<h2 id="die-workloads-starten">Die Workloads starten</h2>
<ul>
<li>Betreiben Sie Ihre Homepage in einem Docker-Container mit dem Namen <code>homepage</code></li>
<li>Betreiben Sie Matomo in einem Docker-Container mit dem Namen <code>matomo</code></li>
<li>Beide Container müssen sich im selben Docker-Netzwerk wie Traefik befinden</li>
</ul>
<h2 id="ein-paar-anmerkungen">Ein paar Anmerkungen</h2>
<ul>
<li>Gültige Zertifikate werden automatisch erzeugt, gespeichert und erneuert.</li>
<li>Führen Sie <code>restart.sh</code> nicht zu häufig aus. Andernfalls gilt eine Sperrfrist von einer Woche. Siehe <a href="https://letsencrypt.org/docs/rate-limits/">diesen Beitrag von Let&#39;s Encrypt</a>.</li>
<li>Änderungen in <code>configuration/conf.yaml</code> werden überwacht, d.h. beim Ändern dieser Datei ist kein Neustart erforderlich.</li>
<li>HTTP-Anfragen auf Port 80 werden zu TLS auf Port 443 weitergeleitet.</li>
<li>Das Traefik-Dashboard ist auf Port <code>:8123</code> erreichbar. Es empfiehlt sich, Port 8123 (das Traefik-Dashboard) per Firewall-Regel zu blockieren. Es müssen nur die Ports 443 und ggf. 80 nach außen offen sein.</li>
</ul>

</div>
`;
export default htmlContent
